import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import SettingsActionsSwitcher from '../SettingsActions/SettingsActionsSwitcher';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  text: PropTypes.string.isRequired,
  setAlert: PropTypes.func.isRequired,
};

const defaultProps = {
  children: undefined,
};

const SettingsHeader = ({
  children,
  text,
  setAlert,
}) => (
    <div className={styles.heading}>
      <h1 className={styles.text}>{text}</h1>
      {children}
      <SettingsActionsSwitcher settingsTitle={text} setAlert={setAlert} />
    </div>
);

SettingsHeader.propTypes = propTypes;
SettingsHeader.defaultProps = defaultProps;

export default SettingsHeader;
